import React from 'react';
import { IonChip, IonIcon, IonLabel, useIonModal } from '@ionic/react';
import { unlinkOutline } from 'ionicons/icons';
import { useTranslation } from '../hooks/useTranslation';
import DeviceHealthModal from '../modals/DeviceHealthModal';
import { modalController } from '@ionic/core';

interface ConnectivityData {
    connected: boolean;
    disconnectReason: string | null;
    timestamp: number;
}

interface DeviceConnectivityChipProps {
    deviceId: string;
    connectivity?: ConnectivityData;
    style?: React.CSSProperties;
}

const DeviceConnectivityChip: React.FC<DeviceConnectivityChipProps> = ({
    deviceId,
    connectivity,
    style
}) => {
    const { t } = useTranslation('components');
    const [presentDeviceHealthModal, dismissDeviceHealthModal] = useIonModal(DeviceHealthModal, {
        dismiss: (data?: string | null | undefined | number, role?: string) => dismissDeviceHealthModal(data, role),
        deviceId
    });

    const handleChipClick = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (connectivity) {
            presentDeviceHealthModal({
                presentingElement: await modalController.getTop()
                    || document.getElementsByTagName('ion-router-outlet')[0]
            });
        }
    };

    if (!connectivity) {
        return <span>-</span>;
    }

    const { connected, disconnectReason, timestamp } = connectivity;

    return (
        <>
            <IonChip
                color={connected ? 'success' : 'danger'}
                style={{ ...style, cursor: 'pointer' }}
                onClick={handleChipClick}
            >
                <IonIcon
                    icon={connected ? undefined : unlinkOutline}
                    src={connected ? '/assets/wifi/wifi-ionicons-v7.svg' : undefined}
                />
                <IonLabel>{connected ? t('device_list_item.online') : t('device_list_item.offline')}</IonLabel>
            </IonChip>
        </>
    );
};

export default DeviceConnectivityChip;
